import { useState } from "react";
import api, { formatApiError } from "../api";
import { useApp } from "../context/AppContext";
import { Seo } from "../components/Seo";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { track } from "../analytics";

export default function Contact() {
  const { site } = useApp();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contact", form);
      track("contact_form_submit");
      toast.success("Message sent. We will contact you soon.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) { toast.error(formatApiError(err)); }
  };
  const input = "w-full h-12 rounded-md border border-input bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring";
  return (
    <div className="max-w-5xl mx-auto px-4 py-10 grid lg:grid-cols-2 gap-10" data-testid="contact-page">
      <Seo title="Contact" description="Contact DocGalaxy for Gujarat property document services." />
      <div>
        <h1 className="font-display font-bold text-3xl md:text-4xl">Contact Us</h1>
        <p className="text-muted-foreground mt-2">Rajkot-first team, serving all Gujarat.</p>
        <div className="mt-6 space-y-3 text-sm">
          <p><strong>Phone:</strong> <a href={`tel:${site.phone}`} className="text-primary" data-testid="contact-phone" onClick={() => track("phone_click", { placement: "contact_page" })}>{site.phone}</a></p>
          <p><strong>WhatsApp:</strong> <a href={`https://wa.me/${site.whatsapp}`} className="text-secondary" data-testid="contact-whatsapp" target="_blank" rel="noopener noreferrer" onClick={() => track("whatsapp_click", { placement: "contact_page" })}>{site.whatsapp}</a></p>
          <p><strong>Email:</strong> {site.email}</p>
          <p><strong>Address:</strong> {site.address}</p>
        </div>
      </div>
      <form onSubmit={submit} className="bg-white border border-border rounded-xl p-6 space-y-4" data-testid="contact-form">
        {[["name", "Name"], ["email", "Email"], ["phone", "Phone"]].map(([k, label]) => (
          <div key={k}>
            <label className="text-xs font-semibold">{label}</label>
            <input className={input} required={k !== "phone"} type={k === "email" ? "email" : "text"} value={form[k]}
              onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`contact-${k}`} />
          </div>
        ))}
        <div>
          <label className="text-xs font-semibold">Message</label>
          <textarea className={`${input} h-28 py-2`} required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
        </div>
        <Button type="submit" className="bg-primary h-11 px-8" data-testid="contact-submit-btn">Send Message</Button>
      </form>
    </div>
  );
}
